export const StoreAction = {
    // SET_REGISTRATION_DATA:"SET_REGISTRATION_DATA",
    // GET_REGISTRATION_DATA:"GET_REGISTRATION_DATA",
    GET_LOGIN_DATA:"GET_LOGIN_DATA",
    SET_STORE_DATA:"SET_STORE_DATA",
    GET_STORE_DATA:"GET_STORE_DATA",
    SET_CATEGORY_DATA:"SET_CATEGORY_DATA",
    SET_STAFF_DATA:"SET_STAFF_DATA",
}